import React, {useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import {Box, Button, Grid, MenuItem, MobileStepper} from "@material-ui/core";
import {MUICardWithControl, MUISelect} from "./formUtils";
import addressData from "../data/addressData.json";
import {KeyboardArrowLeft, KeyboardArrowRight} from "@mui/icons-material";
import {makeStyles} from "@material-ui/core/styles";
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import BrokenImageRoundedIcon from '@mui/icons-material/BrokenImageRounded';

const useStyles = makeStyles((theme) => ({
    stepperNonMobile: {
        [theme.breakpoints.down('md')]: {//mobile display none
            display: 'none',
        },
        [theme.breakpoints.up('md')]: {
            display: 'block',
            marginLeft: 16,
            marginBottom: 16
        },
        [theme.breakpoints.up('lg')]: {
            display: 'block',
        },
    },
    stepperMobile: {
        [theme.breakpoints.down('md')]: {//mobile display none
            display: 'block',
        },
        [theme.breakpoints.up('md')]: {
            display: 'none',
        }
    },
}));

export function Copyright() {
    return (
        <Typography variant="body2" color="white" align="center">
            {'Copyright © '} {new Date().getFullYear()} {' '}
            <Link color="inherit" href="https://www.fmap.org/" target="_blank">
                 Florida Market Assistance Plan{/* Citizens Property Insurance Corporation */}
            </Link>{'.'}
        </Typography>
    );
}

export function ClaimDetails({
                                 lossTypeName,
                                 lossTypeLabel,
                                 errors,
                                 lossTypeValue,
                                 handleFormChange,
                                 claimStatusName,
                                 claimStatusLabel,
                                 claimStatusValue,
                                 controlObject,
                                 claimLabel, lossTypeDefaultValue, claimStatusDefaultValue
                             }) {
    const [lossTypeList, setLossTypeList] = useState([]);
    // loading static data when component loads
    useEffect(() => {
        // Anything in here is fired on component mount.
        // fetching static data
        setLossTypeList(addressData.lossType);
    }, []);

    return (
        <>
            <Grid item xs={12} sm={12} md={12}>
                <Box component="span" justifyContent="flex-start" alignItems="flex-end" display="flex">
                    <br/>
                    <br/>
                    <b style={{fontSize: 24, fontWeight: 900}}>{claimLabel}</b>
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MUICardWithControl children={
                    <MUISelect id="lossType" control={controlObject} name={lossTypeName}
                               errors={errors}
                               defaultValue={lossTypeDefaultValue}
                               value={lossTypeValue} onFormChange={handleFormChange}>
                        <MenuItem key="none" value="none" disabled>--Select--</MenuItem>
                        {lossTypeList.map(type => {
                            return <MenuItem key={type?.value} value={type?.value}>{type?.label}</MenuItem>
                        })}
                    </MUISelect>
                } label={lossTypeLabel}
                                    icon={<BrokenImageRoundedIcon style={{
                                        backgroundColor: '#3f51b5',
                                        padding: 16,
                                        fontSize: 16,
                                        height: 64,
                                        width: 64,
                                        marginBottom: 16,
                                        color: '#ffffff',
                                        borderRadius: 20
                                    }}/>}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MUICardWithControl children={
                    <MUISelect id="claimStatus" control={controlObject} name={claimStatusName}
                               errors={errors}
                               defaultValue={claimStatusDefaultValue}
                               value={claimStatusValue} onFormChange={handleFormChange}>
                        <MenuItem key="none" value="none" disabled>--Select--</MenuItem>
                        <MenuItem key="Open" value="Open">Open</MenuItem>
                        <MenuItem key="Closed" value="Closed">Closed</MenuItem>
                    </MUISelect>
                } label={claimStatusLabel}
                                    icon={<AssignmentOutlinedIcon style={{
                                        backgroundColor: '#3f51b5',
                                        padding: 16,
                                        fontSize: 16,
                                        height: 64,
                                        width: 64,
                                        marginBottom: 16,
                                        color: '#ffffff',
                                        borderRadius: 20
                                    }}/>}/>
            </Grid>
        </>
    );
}

export function WizardNav({handleBackClick, currentStep, hidePrevious, handleSubmit}) {
    const classes = useStyles();
    return (
        <>
            <Box className={classes.stepperNonMobile}>
                <LeadNonMobileStepper handleBackClick={handleBackClick} activeStep={currentStep} stepLength="6"
                                      hidePrevious={hidePrevious} handleSubmit={handleSubmit}/></Box>
            <Box style={{margin: 0, padding: 0}} className={classes.stepperMobile}>
                <LeadMobileStepper hidePrevious={hidePrevious} handleSubmit={handleSubmit}
                                   activeStep={currentStep} handlePrevious={handleBackClick} stepLength="6"/></Box>
        </>
    );
}

export function LeadNonMobileStepper({handleBackClick, hidePrevious, handleSubmit, stepLength, activeStep}) {
    return (
        <Grid container xs={12} sm={12} md={12} alignItems="flex-start" spacing={2}>
            <Grid item xs={6} sm={6} md={6}>
                <Box component="span" justifyContent="flex-start" marginLeft="16px" marginTop="8px"
                     alignItems="flex-end" display="flex">
                    {!hidePrevious && <Button type="submit" variant="contained" color="primary" name="btnPrevious"
                                              onClick={handleBackClick}><KeyboardArrowLeft/> Back
                    </Button>}
                </Box>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
                <Box component="span" justifyContent="flex-end" marginTop="8px" marginRight="8px" alignItems="flex-end"
                     display="flex">
                    {!handleSubmit &&
                    <Button type="submit" variant="contained" color="primary" name="btnNext">
                        {activeStep === stepLength - 1 && <>Submit</>}
                        {activeStep !== stepLength - 1 && <>Next <KeyboardArrowRight/></>}
                    </Button>}
                    {handleSubmit &&
                    <Button onClick={handleSubmit} variant="contained" color="primary" name="btnNext">
                        Next <KeyboardArrowRight/>
                    </Button>
                    }
                </Box>
            </Grid>
        </Grid>
    );
}

export function LeadMobileStepper({stepLength, activeStep, handlePrevious, hidePrevious, handleSubmit}) {
    return (
        <>
            {!hidePrevious &&
            <MobileStepper style={{backgroundColor:"#3f51b5", color:"white"}}
                variant="text"
                steps={stepLength}
                position="static"
                activeStep={activeStep}
                nextButton={
                    <>
                        {!handleSubmit &&
                        <Button type="Submit"
                                size="small"
                                style={{color:"white", fontWeight:"bold"}}
                        >
                            {activeStep === stepLength - 1 && <b>Submit</b>}
                            {activeStep !== stepLength - 1 && <>Next <KeyboardArrowRight/></>}
                        </Button>}
                        {handleSubmit &&
                        <Button onClick={handleSubmit}
                                size="small" style={{color:"white", fontWeight:"bold"}}
                        >
                            Next <KeyboardArrowRight/>
                        </Button>}
                    </>

                }
                backButton={
                    !hidePrevious &&
                    <Button size="small" style={{color:"white", fontWeight:"bold"}}
                            onClick={handlePrevious}
                    >
                        <KeyboardArrowLeft/> Back
                    </Button>
                }
            />}
            {hidePrevious &&
            <Box component="span" justifyContent="flex-end" alignItems="flex-end" display="flex"
                 style={{marginTop: 10}}>
                <Button type="Submit" size="small">
                    Next <KeyboardArrowRight/>
                </Button>
            </Box>
            }

        </>
    );
}

export function  currencyFormat(value) {
    if (value && !isNaN(Number(value))) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(Number(value));
    } else {
        return '';
    }
}


export function downloadFile(data, fileName) {
    const blob = new Blob([makeCSV(data)], {type: 'text/csv;charset=utf-8;'});
    let fileUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.download = fileName;
    a.href = fileUrl;
    const clickEvt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
    URL.revokeObjectURL(fileUrl)
}

export function makeCSV(content){
    let csv = '';
    content.forEach(value => {
        value.forEach((item, i) => {
            let innerValue = item === null || item === undefined ? '' : item.toString();
            let result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0) {
                result = '"' + result + '"'
            }
            if (i > 0) {csv += ','}
            csv += result;
        })
        csv += '\n';
    })
    return csv
}

export  function handleCountyConversion(countyValue, countyList) {
    if (countyValue) {
        countyValue = countyValue.replace(' County', '');
        if (countyValue.includes('St. Lucie') || countyValue.includes('Saint Lucie') || countyValue.includes('St Lucie')) {
            return 'Saint Lucie';
        } else if (countyValue.includes('Saint Johns') || countyValue.includes('St. Johns') || countyValue.includes('St Johns')) {
            return 'Saint Johns';
        } else {
            let countyFromList = countyList.filter(z => z === countyValue);
            if (countyFromList && countyFromList.length > 0) {
                return countyFromList[0]
            }
        }
    }
    return 'Out of Florida';
}

export function getAddressObject(address_components){
    const ShouldBeComponent = {
        home: ["street_number"],
        postal_code: ["postal_code"],
        street: ["street_address", "route"],
        region: [
            "administrative_area_level_1",
            "administrative_area_level_2",
            "administrative_area_level_3",
            "administrative_area_level_4",
            "administrative_area_level_5"
        ],
        city: [
            "locality",
            "neighborhood",
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4"
        ],
        country: ["country"],
        county: [
            "administrative_area_level_2",
            "political"
        ]
    };

    const address = {
        home: "",
        postal_code: "",
        street: "",
        region: "",
        city: "",
        country: "",
        county: ""
    };
    address_components.forEach(component => {
        for (let shouldBe in ShouldBeComponent) {
            if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                if (shouldBe === "country") {
                    address[shouldBe] = component.short_name;
                } else {
                    address[shouldBe] = component.long_name;
                }
            }
        }
    });
    return address;
}

export function handleCountryConversion(countryCode) {
    if (countryCode?.toLowerCase() === 'us') {
        return 'United States';
    } else if (countryCode?.toLowerCase() === 'pr') {
        return 'Puerto Rico';
    } else if (countryCode?.toLowerCase() === 'vi') {
        return 'U.S. Virgin Islands';
    } else if (countryCode?.toLowerCase() === 'gu') {
        return 'Guam';
    } else if (countryCode?.toLowerCase() === 'mp') {
        return 'Northern Mariana Islands';
    } else if (countryCode?.toLowerCase() === 'as') {
        return 'American Samoa';
    }
    return 'United States';
}
